<template>
  <div class="image-text u-row u-pad-y-xl u-pad-y-lg--sm u-pad-y-md--sm u-middle u-left">
    <div v-if="data.direction" class="u-w5of12 u-w10of12--sm u-marg-l-1of12 u-marg-b-md--sm">
      <app-image :id="data.image[0].id" :src="data.image[0].url" class="u-block u-full-width" />
    </div>
    <div class="u-w4of12 u-w10of12--sm u-marg-l-1of12">
      <h3 class="t-h3">{{ data.titre }}</h3>
      <div class="u-marg-t-md">
        <app-button v-for="link in data.links" :isGhost="true" :key="link.href" class="u-marg-r-md u-inline-block t-text t-text--xsmall" :url="link.href">
          <!-- dirty fix that allows to reach property -->
          <!-- if name is used, weird API bug from craft -->
          {{ link.col1 }}
        </app-button>
      </div>
      <p class="u-marg-t-md t-text">
        {{ data.text }}
      </p>
    </div>
    <div v-if="!data.direction" class="u-w5of12 u-w10of12--sm u-marg-l-1of12 u-marg-t-md--sm">
      <app-image :id="data.image[0].id" :src="data.image[0].url" class="u-block u-full-width" />
    </div>
  </div>
</template>

<script>
import AppButton from '@/components/common/AppButton'

export default {
  components: {
    AppButton
  },
  props: {
    data: {
      type: Object,
      required: true
    }
  }
}
</script>